import "./medical-tourism.scss";
import MedicalTourismImage from "../../assets/imgs/medical-tourist.png";
import MedicalTourismMultiStepForm from "../../components/view/medical-tourism-multi-step-form/medical-tourism-multi-step-form";
import { useTranslation } from "react-i18next";

//import general components
import Footer from "../../components/common/footer/footer";

const MedicalTourism = () => {
    const { t } = useTranslation();
    return (
        <>
            <div className="medical-tourism-container">
                <div className="medical-tourism-wrapper">
                    <div className="right-side">
                        <div className="medical-title-and-description-wrapper">
                            <div className="medical-title">{t("healthTourTitle")}</div>
                            <div className="medical-description">{t("healthTourDescription")}</div>
                        </div>
                        <div style={{ paddingX: "2rem" }}>
                            <MedicalTourismMultiStepForm />
                        </div>
                    </div>
                    {/* <div className="left-side">
                    <img src={MedicalTourismImage} alt="medical" />
                </div> */}
                </div>
                <div className="bottom-side">
                    <Footer />
                </div>
            </div>
        </>
    );
};

export default MedicalTourism;
